import { Component, Pipe, PipeTransform, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

import { AssetsService } from '../common/services/assets.service';
import { MessagesService } from '../common/services/messages.service';
import { Bus } from '../common/services/bus';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  public isEventSet = false;
  public isAppSet = false;
  public isCompanySet = false;
  public currentTime: any;
  public roomNumber: string;
  public roomName: string;
  public logo: string;
  public slogan: string;
  public localCss: string;
  constructor(private service: MessagesService,
  private bus: Bus,
  private assets: AssetsService) {
    this.getTime();

    bus.on('ROOM_SELECTED').subscribe((room) => {
      console.log((<any>room).number);
      this.roomNumber = (<any>room).number;
      this.roomName = (<any>room).name;
     });
  }

  init() {
    this.logo = this.assets.logo();
    this.slogan = this.assets.slogan();
    // this.localCss = this.assets.localCss();
  }

  ngOnInit() {
    this.init();
  }

  // Calculates the time every minute
  private getTime() {
    const now = new Date();
    this.currentTime = now.getTime();
    setTimeout( () => {
      this.getTime();
    }, 60000 - (now.getSeconds() * 1000));
  }

}
